export default __webpack_public_path__ + "static/media/4e.0d511f8b.png";